import { useOutletContext } from 'react-router-dom';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import GalleryButtons from './GalleryButtons';
import QRCodeCarousel from "./QRCodeCarousel";
import { Carousel } from 'react-responsive-carousel';

export default function Bio() {
    const { section } = useOutletContext<{ section: string }>();

    if (section === "carousel") {
        return <QRCodeCarousel />;
    }
    return (<>
        <div className="grid lg:grid-cols-2  grid-cols-1 justify-center ">
            <div className="w-full px-3 sm:px-8 md:px-16 py-4 sm:py-6">
                <h3 className="text-black !text-[1rem] lg:!text-3xl  lg:text-center-[30px] tracking-wide xl:text-3xl  mb-4 text-center md:text-left mt-4 helvetica-neue">
                    Craft an engaging and interactive bio profile to offer your clients a personalized experience.

                </h3>
                <GalleryButtons />
            </div>

          <div className="w-full text-center  px-8 lg:block hidden bg-white ">
                 <h3
                   style={{
                     transform: "scaleY(1.2)",
                   }}
                   className="uppercase text-[#234042] text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[60px] leading-[1.2] text-left  mb-4 mt-4"
                 >
                   Built-in{" "}
                   <span
                     className="text-white font-[Bebas Neue] tracking-[2px] uppercase"
                     style={{
                       WebkitTextStroke: "1px #F47321",
                     }}
                   >
                     QR CODE
                   </span>
                   <br />
                   Generators Simplified
                 </h3>

                  <img src="/images/4308850 1.svg"  className="w-full max-w-md mx-auto" />
         
                 {/* <Carousel
                   autoPlay
                   infiniteLoop
                   interval={2000}
                   showThumbs={false}
                   showArrows={false}
                   showStatus={false}
                   swipeable={true}
                   className="w-full max-w-md mx-auto"
                 >
                   <div><img src="/images/4308850 1.svg" alt="QR 1" /></div>
                   <div><img src="/images/4308850 1.svg" alt="QR 2" /></div>
                   <div><img src="/images/4308850 1.svg" alt="QR 3" /></div>
                 </Carousel> */}
               </div>
        </div >
    </>
    );
}
